module.exports = __webpack_public_path__ + "img/hexa.7694fffa.svg";